import PanelTransitions from '@component/panel/transition';

export default class Transition extends PanelTransitions {
  enableTransitions() {
    this.component.classList.remove('wallpaper--no-transition');
  }

  hiddenToPage() {
    if (!this.animate) {
      this.component.className = 'wallpaper wallpaper--no-transition';
    }

    this.component.classList.add('wallpaper--full-panel');
    return [
      new Promise((resolve) => {
        const actualResolve = () => {
          this.enableTransitions();
          resolve();
        };

        this.exitResolve = actualResolve;
        this.exitTimeout = setTimeout(actualResolve, this.settings.duration);
      }),
    ];
  }

  hiddenToPlus() {
    if (!this.animate) {
      this.component.className = 'wallpaper wallpaper--no-transition';
    }

    this.component.classList.add('wallpaper--half-panel');
    return [
      new Promise((resolve) => {
        const actualResolve = () => {
          this.enableTransitions();
          resolve();
        };

        this.exitResolve = actualResolve;
        this.exitTimeout = setTimeout(actualResolve, this.settings.duration);
      }),
    ];
  }

  plusToPage() {
    this.component.classList.remove('wallpaper--half-panel');
    this.component.classList.add('wallpaper--full-panel');
    return [];
  }

  pageToPlus() {
    this.component.classList.remove('wallpaper--full-panel');
    this.component.classList.add('wallpaper--half-panel');
    return [];
  }

  anyToHidden() {
    this.component.classList.remove('wallpaper--half-panel');
    this.component.classList.remove('wallpaper--full-panel');
    return [
      new Promise((resolve) => {
        this.exitResolve = resolve;
        this.exitTimeout = setTimeout(resolve, this.settings.duration);
      }),
    ];
  }
}
